var _templateObject, _templateObject2;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import { bool } from 'prop-types';
import React from 'react';
import styled, { css, withTheme } from 'styled-components';
var StyledDivider = styled.hr(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var vertical = _ref.vertical,
      _ref$theme$yoga = _ref.theme.yoga,
      borders = _ref$theme$yoga.borders,
      colors = _ref$theme$yoga.colors;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      ", ";\n      border-width: 0px;\n      border-left-width: ", "px;\n      border-bottom-width: ", "px;\n      border-color: ", ";\n    "])), vertical ? 'height: auto' : 'width: 100%', vertical ? borders.small : 0, vertical ? 0 : borders.small, colors.text.disabled);
});
var Divider = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var vertical = _ref2.vertical;
  return /*#__PURE__*/React.createElement(StyledDivider, {
    vertical: vertical,
    ref: ref
  });
});
Divider.propTypes = {
  /** If this value is defined, the divider will be in vertical if the flexDirection is row type */
  vertical: bool
};
Divider.defaultProps = {
  vertical: false
};
export default withTheme(Divider);